import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { computed, type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useTourSeoInfo = (
  tourType: MaybeRefOrGetter<string>,
  tourId: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean>,
) => {
  const loaderStore = useLoaderStore();
  const { getTourSeoById } = useExperienceApi();

  const {
    data: tourSeoData,
    isSuccess,
    isFetching,
  } = useQuery({
    queryKey: ['tourSeoInfo', tourType, tourId],
    queryFn: async () => {
      const response = await getTourSeoById({
        path: { tourType: unref(tourType) as string },
        query: { ids: unref(tourId) as string },
      });

      loaderStore.check404(response);

      return response;
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    tourSeoData,
    isSuccess,
    isFetching,
  };
};
